import { useEffect } from 'react'

function normalizeHost(hostname = '') {
  return hostname.replace(/^www\./, '').toLowerCase()
}

function getBrandedTitle(hostname) {
  const h = normalizeHost(hostname)
  if (h === 'qoriax.com' || h === 'coriex.com' || h.startsWith('saas.qoriax') || h.includes('qoriax-main-deploy')) {
    return 'QorIAX — Plataforma SaaS'
  }
  if (h === 'prover.com.py' || h.includes('prover')) {
    return 'ProVer | Clínica Oftalmológica en Asunción'
  }
  if (h === 'clarahospital.com' || h.includes('clarahospital')) {
    return 'Clara Hospital | Centro Médico Santa Clara en Nueva Esperanza'
  }
  return null
}

function getFaviconPath(hostname) {
  const h = normalizeHost(hostname)
  if (h === 'prover.com.py' || h.includes('prover')) {
    return '/tenants/prover/prover-isotipo-official.jpg'
  }
  if (h === 'clarahospital.com' || h.includes('clarahospital')) {
    return '/favicon-santa-clara-limpio.png'
  }
  if (h === 'qoriax.com' || h === 'coriex.com' || h.startsWith('saas.qoriax') || h.includes('qoriax-main-deploy')) {
    return '/favicon-qoriax.svg'
  }
  return '/favicon.svg'
}

function applyFavicon(hostname) {
  const href = getFaviconPath(hostname)
  let link = document.querySelector("link[rel='icon']")
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = href
}

export function useHostBranding() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    const hostname = window.location.hostname
    const brandedTitle = getBrandedTitle(hostname)
    if (brandedTitle) document.title = brandedTitle
    applyFavicon(hostname)
  }, [])
}
